module.exports = __webpack_public_path__ + "static/media/s_cur_04.64fa747f.png";